// NAVER SA ad_channel → 한글 라벨 (매체 집계/엑셀/리포트 3곳 공유 — 드리프트 금지)
// 판별은 ad_channel 값으로만 (캠페인명 prefix 금지 — Rule 175).
// 빈 ad_channel → "기타" 격리 (POWERLINK 폴백 금지).
export const NAVER_SA_CHANNEL_LABEL = {
  POWERLINK: "파워링크",
  SHOPPING: "쇼핑검색",
  BRAND_SEARCH: "브랜드검색",
  "": "기타",
};

// 매체 집계 표시 키 — Google SA 컨벤션(공백 구분 "Google SA") 미러: "NAVER SA 파워링크"
export const naverSaMediaKey = (adChannel) =>
  "NAVER SA " + (NAVER_SA_CHANNEL_LABEL[adChannel] ?? "기타");

// 표/카드 노출 순서 키 (파워링크→쇼핑검색→브랜드검색→기타)
export const NAVER_SA_MEDIA_KEYS = [
  "NAVER SA 파워링크",
  "NAVER SA 쇼핑검색",
  "NAVER SA 브랜드검색",
  "NAVER SA 기타",
];

// B2 후속: 브랜드검색 세트 행(ad_id="" → ad_name="")의 소재명 표시 라벨.
// 소재 그룹핑에서 "(미지정)"/빈칸으로 떨어지는 것 방지 — 표시 전용(집계 키·숫자 무접촉).
// 판별은 ad_channel 값으로만(위 원칙 동일). 파워링크·쇼핑 세트 행(ad_name="")은 대상 아님.
export const BS_SET_ROW_LABEL = "브랜드검색 (세트 단위 · 정액)";
export const bsSetRowAdNameLabel = (row) =>
  row && !row.ad_name && row.ad_channel === "BRAND_SEARCH"
    ? BS_SET_ROW_LABEL
    : null;

// B3: BS 치환 시 세트 광고비 보존 행 라벨 — 지표 칸은 표시 "—"(합산 0), spend만 세트값 유지.
export const BS_FLAT_SET_ROW_LABEL = "브랜드검색 정액 (세트)";

// B6 Task 2 — 라이브 필터: 선택 기간 내 일별 키(NAVER_BS_CREATIVE_DAILY) 없는 종료 소재의
// GA4 잔여를 1행으로 합산할 때의 소재명(표시 전용 — buildBsCreativeRows가 name 대입).
export const BS_RETIRED_CREATIVE_LABEL = "(종료 소재 잔여)";

// B6F — 세트 귀속 합계 − 소재 분해 합계(스코프 내 GA4)의 차이(옛·스코프 밖 캠페인 잔존 귀속분).
// 숨김 금지: 화면 = 정액 행 ⓘ 툴팁, 엑셀 = 정액 행 소재명 접미(둘 다 이 SSOT — 드리프트 금지).
const wonFmt = (n) => `₩${Math.round(Number(n) || 0).toLocaleString("ko-KR")}`;
// 음수 diff(소재 분해 합 > 세트 귀속 합) = 중복·귀속 불일치 신호 — 0 클램프로 숨기지 않고
// 정합 이상 문구로 분기(Codex 지적: 이상 상태가 정상처럼 통과하는 것 차단).
const bsDiffNegative = (u) => Number(u?.rev) < 0 || Number(u?.cv) < 0;
export const bsUnattributedTooltip = (u) =>
  `세트 귀속 합계와 소재 분해 합계의 차이 ${wonFmt(u?.rev)} · 전환 ${Math.round(Number(u?.cv) || 0)} — ${
    bsDiffNegative(u)
      ? "정합 이상(소재 분해 합 > 세트 귀속 합) — 데이터 확인 필요"
      : "스코프 밖(종료 등) 캠페인 잔존 세션 귀속분(소재 분해 불가)"
  }`;
export const bsFlatRowExcelLabel = (u) =>
  `${BS_FLAT_SET_ROW_LABEL} · ${bsDiffNegative(u) ? "정합 이상" : "미분해 잔존"} ${wonFmt(u?.rev)}`;
